var map = {
	"./header-about.jpg": 6690,
	"./header-acousticguitar.jpg": 7796,
	"./header-bass.jpg": 133,
	"./header-contact.jpg": 5354,
	"./header-drums.jpg": 7536,
	"./header-electricguitar.jpg": 4908,
	"./header-faq.jpg": 8351,
	"./header-keyboard.jpg": 997,
	"./header-piano.jpg": 8621,
	"./header-trumpet.jpg": 628,
	"./header-ukulele.jpg": 5880,
	"./header-violin.jpg": 9781,
	"./header-vocals.jpg": 2793
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4014;